import React, { useState, useEffect, useRef } from 'react';

/**
 * SessionTicker
 * Displays elapsed time since `enteredAt` with 1-second precision.
 * Uses requestAnimationFrame internally but only triggers React re-render each second.
 *
 * @param {string} enteredAt - ISO date string of check-in time
 * @param {boolean} [showSeconds=true]
 */
function SessionTicker({ enteredAt, showSeconds = true }) {
  const [display, setDisplay] = useState('');
  const rafRef = useRef(null);
  const lastSecRef = useRef(-1);

  useEffect(() => {
    const entered = new Date(enteredAt).getTime();

    const tick = () => {
      const elapsed = Math.floor((Date.now() - entered) / 1000);
      if (elapsed !== lastSecRef.current) {
        lastSecRef.current = elapsed;
        const h = Math.floor(elapsed / 3600);
        const m = Math.floor((elapsed % 3600) / 60);
        const s = elapsed % 60;

        if (showSeconds) {
          setDisplay(
            h > 0
              ? `${h}h ${String(m).padStart(2, '0')}m ${String(s).padStart(2, '0')}s`
              : `${m}m ${String(s).padStart(2, '0')}s`
          );
        } else {
          setDisplay(h > 0 ? `${h}h ${m}m` : `${m}m`);
        }
      }
      rafRef.current = requestAnimationFrame(tick);
    };

    rafRef.current = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(rafRef.current);
  }, [enteredAt, showSeconds]);

  return <span>{display}</span>;
}

export default SessionTicker;
